export function ArrowSvg({ className }: { className?: string }) {
  return (
    <svg
      width="20"
      height="10"
      viewBox="0 0 20 10"
      fill="none"
      className={className}
    >
      {/* Main arrow body - extend to bottom and beyond to overlap with tooltip */}
      <path
        d="M4.8076 6.9732C4.0731 7.6342 3.1199 8 2 8V9L19 9V8H18C17.5468 8 16.5936 7.6342 15.8591 6.9732L11.0023 2.6021C10.622 2.2598 10.0447 2.2598 9.6644 2.6021Z"
        className="fill-surface-3 translate-y-[-0.7px]"
      />
      {/* Border stroke - simplified to just the visible angled lines */}
      <path
        d="M8.9954 1.8588c.7606-.6845 1.9152-.6846 2.6759 0l4.8568 4.3711C17.0789 6.7257 17.7938 7 18 7h1M1 7H2c.8728 0 1.5877-.2743 2.1386-.7701L8.9954 1.8588"
        className="stroke-transparent"
      />
    </svg>
  )
}

export function ArrowSvgSmaller({ className }: { className?: string }) {
  return (
    <svg
      width="14"
      height="7"
      viewBox="0 0 20 10"
      fill="none"
      className={className}
    >
      {/* Main arrow body - extend to bottom and beyond to overlap with tooltip */}
      <path
        d="M4.8076 6.9732C4.0731 7.6342 3.1199 8 2 8V9L19 9V8H18C17.5468 8 16.5936 7.6342 15.8591 6.9732L11.0023 2.6021C10.622 2.2598 10.0447 2.2598 9.6644 2.6021Z"
        className="fill-surface-3 translate-y-[-0.7px]"
      />
      {/* Border stroke - simplified to just the visible angled lines */}
      <path
        d="M8.9954 1.8588c.7606-.6845 1.9152-.6846 2.6759 0l4.8568 4.3711C17.0789 6.7257 17.7938 7 18 7h1M1 7H2c.8728 0 1.5877-.2743 2.1386-.7701L8.9954 1.8588"
        className="stroke-transparent"
        strokeWidth={1.43}
      />
    </svg>
  )
}
